// import Link from "@mui/material/Link";
// import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

const SideBanner = () => {
    return (
  
        <Grid item xs={10} sm={10} md={8} sx={{ color: "white" }}>
                <Box mb={3}>
                  <img
                    src="/assets/Primary_Logo_gold_icon.svg"
                    width="100px"
                  />
                </Box>
                
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ fontWeight: "500" }}
                >
                  Welcome to
                </Typography>
                <Typography
                  variant="h3"
                  component="h3"
                  sx={{ color: "#ff8d24", fontWeight: "500" }}
                >
                  SenseOps
                </Typography>
                <Typography variant="body2" mt={2}>
                Reimagine Qlik Sense experiences with modern devOps, embedding and extensions.
                </Typography>
                <Box sx={{ display: "flex" }} mt={3}>
                  
                  <Tooltip title="Code Management">
                  <img alt="Code Management" src="/assets/Elements/CodeManagement.svg" />
                  </Tooltip>
                  <Tooltip title="Custom Integration">
                  <img alt="Custom Integration"
                    src="/assets/Elements/CustomIntegration.svg"
                    style={{ margin: "0 25px" }}
                  />
                  </Tooltip>
                  <Tooltip title="App Extensions">
                  <img alt="App Extensions" src="/assets/Elements/AppExtension.svg" />
                  </Tooltip>
                  
                </Box>

             

                <Typography variant="body2" mt={3} mb={3}>
                No-code solutions to accelerate insights and adoption from your Qlik analytics.
                </Typography>
              </Grid>

    )
}

export default SideBanner;